import { useState, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with an eye-toggle to reveal/hide the value.
 * Accepts the same props as <Input> plus:
 *   - toggleTestId: data-testid for the eye button
 */
const PasswordInput = forwardRef(function PasswordInput(
  { toggleTestId, className = "", ...rest },
  ref
) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        {...rest}
        ref={ref}
        type={show ? "text" : "password"}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={toggleTestId}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-jpa-muted hover:text-jpa-primary transition-colors"
        tabIndex={-1}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
